import Observer from "../../observer/observer.js";
import ModalRelatedProductsSliderPresenter from "./slider.js";

import {
  modelData
} from "../../../mixins/model-data.js";

import {
  defaultModalRelatedProductsData,
  ActionType
} from "../const.js";

export default class ModalRelatedProducts extends Observer {
  constructor() {
    super();

    this._sliderPresenter = null;

    this._data = Object.assign(
        {},
        defaultModalRelatedProductsData
    );

    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this.addObserver(this._handleChangeData);

    window.ModalRelatedProducts = this;
  }

  _processInit({
    wrapperElement,
    sliderOptions
  }) {
    if (!wrapperElement) {
      return;
    }

    this._sliderPresenter = new ModalRelatedProductsSliderPresenter(
        wrapperElement,
        sliderOptions
    );
    this._sliderPresenter.init();
  }

  _processDestroy() {
    if (!this._sliderPresenter) {
      return;
    }

    this._sliderPresenter.destroy();
    this._sliderPresenter = null;
  }

  _handleChangeData(action, payload) {
    switch (action) {
      case ActionType.INIT_RELATED:
        this._processInit(payload);
        break;
      case ActionType.DESTROY_RELATED:
        this._processDestroy();
        break;
    }
  }
}

Object.assign(ModalRelatedProducts.prototype, modelData);
